import {Injectable, Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'titleCase'
})
@Injectable()
export class TitleCasePipe implements PipeTransform {

  /**
   * @desc return title case the input
   * @param input
   * @param noTitleCaseList - if the input word is in this list, no title case
   *                                 input = "ESS_CHARGE_CODE" and noTitleCasePartialList = ["ESS_CHARGE_CODE"] will return ESS_CHARGE_CODE
   * @param noTitleCasePartialList - any word included in this list will not be title cased e.g.
   *                                 input = "ESS_CHARGE_CODE" and noTitleCasePartialList = ["ESS"] will return ESS Charge Code
   */
  transform(input: string, noTitleCaseList?: string[], noTitleCasePartialList?: string[]): string {
    if (!input) {
      return '';
    } else {
      if (noTitleCaseList && noTitleCaseList.find(ele => ele == input)) {
        return input;
      } else {
        // regular expression for propositions to lower case
        const propositions = /\b(Of|By|To|For|And|Or)\b/g;

        return input
          .replace(/_/g, ' ')
          .replace(/\w\S*/g, (txt => {
            if (noTitleCasePartialList && noTitleCasePartialList.find(ele => ele == txt)) {
              return txt;
            } else {
              return txt[0].toUpperCase() + txt.substr(1).toLowerCase();
            }
          }))
          .replace(propositions, (match) => {
            return match.toLowerCase();
          });
      }
    }
  }
}
